import { config } from 'src/config'

import type { EventKeysType } from '../Resources/Statistics/List'

const { featureExport } = config.features

export const eventsKeys = {
  firstOpen: [
    'deviceId',
    'recordedAt',
    featureExport ? 'partnerCode' : undefined,
  ],
  stepValidated: [
    'deviceId',
    'customerNumber',
    'recordedAt',
    'stepIndex',
    'stepId',
    'stepName',
    'userId',
    featureExport ? 'partnerCode' : undefined,
  ],
  stepTaskEdited: [
    'deviceId',
    'customerNumber',
    'recordedAt',
    'stepIndex',
    'stepId',
    'stepName',
    'taskIndex',
    'taskId',
    'taskName',
    'newState',
    'userId',
    featureExport ? 'partnerCode' : undefined,
  ],
  callSupport: [
    'deviceId',
    'customerNumber',
    'recordedAt',
    'userId',
    featureExport ? 'partnerCode' : undefined,
  ],
  viewItem: [
    'deviceId',
    'customerNumber',
    'recordedAt',
    'itemId',
    'itemName',
    'itemType',
    'userId',
    featureExport ? 'partnerCode' : undefined,
  ],
  viewScreen: [
    'deviceId',
    'customerNumber',
    'recordedAt',
    'screenClass',
    'screenName',
    'userId',
    'stepIndex',
    'stepId',
    'stepName',
    featureExport ? 'partnerCode' : undefined,
  ],
} as Record<EventKeysType, (string | undefined)[]>
